import { AuthRepository } from '../repositories/AuthRepository';

export class RequestRemoveAccount {
  constructor(private repository: AuthRepository) {}

  execute(): Promise<void> {
    return this.repository.requestRemoveAccount();
  }
}